const mutations = {
  setQuestionInForm: (state, question) => {
    state.questionInForm = question;
  }
};

export default mutations;
